import { Component, OnInit } from '@angular/core';
import { IIncidentStatistics } from '../../interfaces/incident';
import { IncidentsService } from '../../services';

@Component({
  selector: 'incidents-statistics',
  templateUrl: './incidents-statistics.component.html',
})
export class IncidentsStatisticsComponent implements OnInit {
  statistics: IIncidentStatistics;

  constructor(private incidentsService: IncidentsService) {}

  ngOnInit(): void {
    this.incidentsService.getStatistics().then((res) => {
      this.statistics = res;
    });
  }
}
